import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";

type State = {
  por: string;
  disciplina: string;
  prancha: string;
  revisao: string;
};

type Actions = {
  setPor: SetFunction<string>;
  setDisciplina: SetFunction<string>;
  setPrancha: SetFunction<string>;
  setRevisao: SetFunction<string>;
};
export const initialDisciplinasFiltersState: State = {
  disciplina: "",
  por: "",
  prancha: "",
  revisao: "",
};

export const useFiltersDisciplinas = create<State & Actions>((set) => ({
  ...initialDisciplinasFiltersState,
  setDisciplina: (vfn) => SetFunctionImpl(set, 'disciplina', vfn),
  setPor: (vfn) => SetFunctionImpl(set, 'por', vfn),
  setPrancha: (vfn) => SetFunctionImpl(set, 'prancha', vfn),
  setRevisao: (vfn) => SetFunctionImpl(set, 'revisao', vfn),
}));
